import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes('/login')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const login = (data) => api.post('/auth/login', data);
export const register = (data) => api.post('/auth/register', data);
export const getMe = () => api.get('/auth/me');
export const updateLocation = (data) => api.post('/auth/location', data);

// Dashboard
export const getDashboardStats = () => api.get('/dashboard/stats');

// Work Orders
export const getWorkOrders = (params) => api.get('/work-orders', { params });
export const getWorkOrder = (id) => api.get(`/work-orders/${id}`);
export const createWorkOrder = (data) => api.post('/work-orders', data);
export const updateWorkOrder = (id, data) => api.patch(`/work-orders/${id}`, data);
export const techUpdateWorkOrder = (id, data) => api.patch(`/work-orders/${id}/tech-update`, data);
export const deleteWorkOrder = (id) => api.delete(`/work-orders/${id}`);
export const addNote = (id, data) => api.post(`/work-orders/${id}/notes`, data);
export const getNotes = (id) => api.get(`/work-orders/${id}/notes`);
export const addPartToOrder = (id, data) => api.post(`/work-orders/${id}/parts`, data);
export const getWorkOrderParts = (id) => api.get(`/work-orders/${id}/parts`);

// Part Requests
export const getPartRequests = (id) => api.get(`/work-orders/${id}/part-requests`);
export const createPartRequest = (id, data) => api.post(`/work-orders/${id}/part-requests`, data);
export const updatePartRequest = (id, prId, data) => api.patch(`/work-orders/${id}/part-requests/${prId}`, data);
export const deletePartRequest = (id, prId) => api.delete(`/work-orders/${id}/part-requests/${prId}`);

// Photos / Attachments
export const getPhotos = (id) => api.get(`/work-orders/${id}/photos`);
export const uploadPhoto = (id, formData) => api.post(`/work-orders/${id}/photos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deletePhoto = (id, photoId) => api.delete(`/work-orders/${id}/photos/${photoId}`);

// Technicians
export const getTechnicians = () => api.get('/technicians');
export const createTechnician = (data) => api.post('/technicians', data);
export const updateTechnician = (id, data) => api.patch(`/technicians/${id}`, data);
export const getMapData = () => api.get('/technicians/map-data');

// Parts
export const getParts = (params) => api.get('/parts', { params });
export const createPart = (data) => api.post('/parts', data);
export const updatePart = (id, data) => api.patch(`/parts/${id}`, data);
export const deletePart = (id) => api.delete(`/parts/${id}`);
export const adjustStock = (id, adjustment) => api.post(`/parts/${id}/adjust-stock?adjustment=${adjustment}`);

// Invoices
export const getInvoices = () => api.get('/invoices');
export const createInvoice = (data) => api.post('/invoices', data);
export const updateInvoice = (id, data) => api.patch(`/invoices/${id}`, data);
export const downloadInvoicePDF = (id) => api.get(`/invoices/${id}/pdf`, { responseType: 'blob' });

// AI
export const diagnose = (data) => api.post('/ai/diagnose', data);

// Billing
export const getBillingStatus = () => api.get('/billing/current-plan');
export const createCheckoutSession = (plan) => api.post('/billing/create-checkout-session', { plan });
export const createPortalSession = () => api.post('/billing/create-portal-session');

// Admin (SaaS owner only)
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminCompanies = () => api.get('/admin/companies');

// Permissions (current user)
export const getMyPermissions = () => api.get('/auth/me/permissions');

// Role Management (saas admin only)
export const getRoles = () => api.get('/roles');
export const createRole = (data) => api.post('/roles', data);
export const updateRole = (id, data) => api.put(`/roles/${id}`, data);
export const deleteRole = (id) => api.delete(`/roles/${id}`);
export const getRolePermissions = (id) => api.get(`/roles/${id}/permissions`);
export const assignRolePermissions = (id, data) => api.put(`/roles/${id}/permissions`, data);

// Permission Management (saas admin only)
export const getPermissions = (module) => api.get('/permissions', { params: module ? { module } : {} });
export const createPermission = (data) => api.post('/permissions', data);
export const updatePermission = (id, data) => api.put(`/permissions/${id}`, data);
export const deletePermission = (id) => api.delete(`/permissions/${id}`);

export default api;
